// @flow

export const USER_POPUP_USERS_INIT = 'USER_POPUP_USERS_INIT'
export const USER_POPUP_USERS_ADD = 'USER_POPUP_USERS_ADD'
export const USER_POPUP_USERS_CHANGE_COMMENT = 'USER_POPUP_USERS_CHANGE_COMMENT'
export const USER_POPUP_USERS_DELETE = 'USER_POPUP_USERS_DELETE'
export const USER_POPUP_CLEAR = 'USER_POPUP_CLEAR'
